export default __webpack_public_path__ + "static/media/logoSample5.b4fa260b.png";